import { render, staticRenderFns } from "./AcademyPage.vue?vue&type=template&id=310d7d70&"
import script from "./AcademyPage.vue?vue&type=script&lang=js&"
export * from "./AcademyPage.vue?vue&type=script&lang=js&"
import style0 from "./AcademyPage.vue?vue&type=style&index=0&id=310d7d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports